import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class StudentVerificationService {
  constructor(private authService: AuthService) {}

  /**
   * Envoie un code OTP à l'email étudiant
   *
   * @param email - Email universitaire de l'étudiant
   * @returns Promise void (code envoyé par email)
   */
  sendOtp(email: string): Promise<void> {
    return this.authService.sendOTPCode(email);
  }

  /**
   * Vérifie le code OTP saisi par l'utilisateur
   *
   * @param email - Email universitaire de l'étudiant
   * @param code - Code OTP à 6 chiffres
   * @returns Promise contenant { valid: boolean }
   */
  verifyOtp(email: string, code: string): Promise<{ valid: boolean }> {
    return this.authService.verifyOTPCode(email, code);
  }
}
